import { Controller } from "@hotwired/stimulus"

// Autosaves a single editor field. Each field/row lives in its own tiny
// <form> (data-controller="autosave"); typing schedules a debounced submit,
// blur/change submits immediately. The submit is a Turbo requestSubmit() so the
// response (a turbo-stream replacing the file-settings / columns frame) swaps in
// without a full navigation.
//
// On a successful save we dispatch a window-level "file-layout:edited" event;
// preview_refresh_controller listens for it to mark the live preview stale and
// debounce a re-run. We never block typing: the preview reacts asynchronously,
// and a failed/conflicted save (HTTP 409) re-renders the frame with the fresh
// lock_version so the next edit succeeds.
export default class extends Controller {
  static targets = ["form"]
  static values = { debounce: { type: Number, default: 500 } }

  initialize() {
    this.debounceTimer = null
    this.saved = this.saved.bind(this)
  }

  connect() {
    this.element.addEventListener("turbo:submit-end", this.saved)
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    this.element.removeEventListener("turbo:submit-end", this.saved)
  }

  schedule() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.submit(), this.debounceValue)
  }

  submit() {
    clearTimeout(this.debounceTimer)
    this.element.requestSubmit()
  }

  // A successful save (2xx) tells the preview to refresh; the 409 conflict
  // re-render is reported as success: false by Turbo, so it doesn't re-run the
  // preview off a stale lock_version.
  saved(event) {
    if (event.detail?.success === false) return
    window.dispatchEvent(new CustomEvent("file-layout:edited"))
  }
}
